const EXAMPLES = [
  {
    industry: 'Plumbing',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20plumber%20fixing%20pipes%20under%20a%20kitchen%20sink%20in%20a%20clean%20modern%20home%2C%20skilled%20tradesperson%20in%20uniform%20with%20tools%2C%20bright%20well-lit%20interior%2C%20confident%20expert%20at%20work%2C%20warm%20natural%20lighting%2C%20photorealistic%2C%20no%20text%2C%20simple%20clean%20background&width=600&height=400&seq=ls-ex-plumbing-01&orientation=landscape',
    hook: 'A leaking pipe at 11pm is not a tomorrow problem.',
    headline: '24/7 Emergency Plumbing. Licensed. Same-Day Service.',
    cta: 'Call Now — We\'re Available',
    platform: 'Google Ads',
    platformIcon: 'ri-google-fill',
    result: '+420% more emergency calls',
  },
  {
    industry: 'Cleaning',
    icon: 'ri-sparkling-line',
    image: 'https://readdy.ai/api/search-image?query=professional%20house%20cleaner%20in%20uniform%20cleaning%20a%20bright%20modern%20living%20room%2C%20sparkling%20clean%20surfaces%20and%20organized%20space%2C%20warm%20natural%20light%20streaming%20through%20windows%2C%20satisfied%20professional%20at%20work%2C%20photorealistic%2C%20no%20text%2C%20clean%20minimal%20background&width=600&height=400&seq=ls-ex-cleaning-01&orientation=landscape',
    hook: 'Life\'s too short to spend your weekends cleaning.',
    headline: 'Professional Home Cleaning. Book Online in 60 Seconds.',
    cta: 'Get My Free Quote',
    platform: 'Facebook',
    platformIcon: 'ri-facebook-circle-fill',
    result: '3.1x more booking requests',
  },
  {
    industry: 'HVAC',
    icon: 'ri-temp-hot-line',
    image: 'https://readdy.ai/api/search-image?query=HVAC%20technician%20servicing%20an%20air%20conditioning%20unit%20on%20the%20side%20of%20a%20modern%20home%2C%20professional%20in%20uniform%20with%20tools%2C%20sunny%20suburban%20neighborhood%20background%2C%20skilled%20tradesperson%20at%20work%2C%20warm%20natural%20lighting%2C%20photorealistic%2C%20no%20text&width=600&height=400&seq=ls-ex-hvac-01&orientation=landscape',
    hook: 'Your AC breaking in July is not a coincidence. It\'s a warning.',
    headline: 'AC Tune-Up Special — $79. Book Before Summer Hits.',
    cta: 'Schedule My Tune-Up',
    platform: 'Instagram',
    platformIcon: 'ri-instagram-fill',
    result: '3.6x return on ad spend',
  },
];

export default function LocalServicesExamples() {
  return (
    <section className="py-20 lg:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">
            Real Ad Examples
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            Service-Specific Ads That Keep the Phone Ringing
          </h2>
          <p className="text-base text-stone-500 max-w-xl mx-auto">
            AdForge knows local services. Here&apos;s what AI-generated{' '}
            <strong>local service advertising</strong> looks like across real trades and services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
          {EXAMPLES.map((ex) => (
            <article
              key={ex.industry}
              className="bg-white rounded-2xl border border-stone-100 overflow-hidden flex flex-col"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={ex.image}
                  alt={`${ex.industry} ad example`}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 bg-white/90 backdrop-blur-sm rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.platformIcon} text-sm text-stone-700`} />
                  </div>
                  <span className="text-xs font-semibold text-stone-700">{ex.platform}</span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1.5 bg-orange-500 rounded-full px-3 py-1.5">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${ex.icon} text-xs text-white`} />
                  </div>
                  <span className="text-xs font-bold text-white">{ex.industry}</span>
                </div>
              </div>

              <div className="p-6 flex flex-col gap-3 flex-1">
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Hook</p>
                  <p className="text-sm text-stone-700 italic leading-relaxed">&ldquo;{ex.hook}&rdquo;</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-1">Headline</p>
                  <p className="text-base font-bold text-stone-900 leading-snug">{ex.headline}</p>
                </div>
                <div className="mt-auto pt-4 border-t border-stone-100 flex items-center justify-between">
                  <span className="inline-block px-4 py-2 bg-orange-500 text-white text-xs font-bold rounded-lg whitespace-nowrap">
                    {ex.cta}
                  </span>
                  <span className="text-xs font-semibold text-green-600 bg-green-50 border border-green-100 rounded-full px-3 py-1">
                    {ex.result}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center text-sm text-stone-400 mt-8">
          AdForge also works for pest control, moving companies, auto repair, tutoring, pet grooming, and more.{' '}
          <a href="/signup" className="text-orange-500 font-semibold hover:underline">Try it free →</a>
        </p>
      </div>
    </section>
  );
}
